import revokeCert from "./revokeCert";
import getRecipientCerts from "./getRecipientCerts";

export default {
	getRecipientCerts,
	revokeCert,
};
